'use client';

import { useContext, type Context } from 'react';

/** Creates a type-safe context hook that throws a helpful error naming `hookName` and `provider` when used outside its provider. */
export function createContextHook<T>(
	context: Context<T | null>,
	hookName: string,
	provider: string | { name: string; errorMessage?: string },
): () => T {
	const providerName = typeof provider === 'string' ? provider : provider.name;
	const customMessage = typeof provider === 'object' ? provider.errorMessage : undefined;
	return function useContextHook(): T {
		const value = useContext(context);
		if (value === null) {
			throw new Error(customMessage ?? `${hookName} must be used within ${providerName}`);
		}
		return value;
	};
}
